import * as updateBidDetailsActions from './updateBidDetails/actions';
import * as assignEntitiesActions from './assignEntities/actions';
import * as customQueryListActions from './customQueries/action';
import * as updateOpenOrdersActions from './updateopenorders/action';
import * as orderPreference from './assignorderpreference/actions';

export const actions = {
  ...updateBidDetailsActions,
  ...assignEntitiesActions,
  ...customQueryListActions,
  ...updateOpenOrdersActions,
  ...orderPreference,
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/actions.js